module.exports = __webpack_public_path__ + "img/Athletic-club.8618e833.png";